/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * EmailIcon component - Icon for email question type
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const EmailIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
    >
      <path
        d='M12.7178 2.52781C6.62781 2.09781 1.59781 7.12781 2.02781 13.2178C2.38781 18.5078 7.00781 22.4978 12.3078 22.4978H15.9978C16.5478 22.4978 16.9978 22.0478 16.9978 21.4978C16.9978 20.9478 16.5478 20.4978 15.9978 20.4978H12.3278C8.59781 20.4978 5.17781 18.0778 4.24781 14.4678C2.75781 8.66781 8.15781 3.25781 13.9578 4.75781C17.5778 5.67781 19.9978 9.09781 19.9978 12.8278V13.9278C19.9978 14.7178 19.2878 15.4978 18.4978 15.4978C17.7078 15.4978 16.9978 14.7178 16.9978 13.9278V12.6778C16.9978 10.1678 15.2178 7.90781 12.7378 7.55781C9.33781 7.06781 6.46781 10.0078 7.07781 13.4278C7.41781 15.3378 8.90781 16.9178 10.7978 17.3678C12.6378 17.7978 14.3878 17.2078 15.5378 16.0378C16.4278 17.2578 18.2078 17.8978 19.8378 17.2478C21.1778 16.7178 21.9978 15.3478 21.9978 13.9078V12.8178C21.9978 7.50781 18.0078 2.88781 12.7178 2.52781ZM11.9978 15.4978C10.3378 15.4978 8.99781 14.1578 8.99781 12.4978C8.99781 10.8378 10.3378 9.49781 11.9978 9.49781C13.6578 9.49781 14.9978 10.8378 14.9978 12.4978C14.9978 14.1578 13.6578 15.4978 11.9978 15.4978Z'
        fill={color}
      />
    </svg>
  )
}

export default EmailIcon
